"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageCropper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_image_crop_1 = __importDefault(require("react-image-crop"));
require("react-image-crop/dist/ReactCrop.css");
let ImageCropper = class ImageCropper extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "src", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "crop", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "image", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getCroppedImg", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type, fileName) => new Promise(resolve => {
                if (!this.image || !this.crop) {
                    resolve(undefined);
                    return;
                }
                const { x, y } = this.crop;
                if (x == null || y == null) {
                    resolve(undefined);
                    return;
                }
                const { width, height } = this.props.crop;
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                if (!ctx) {
                    resolve(undefined);
                    return;
                }
                ctx.drawImage(this.image, x * (this.image.naturalWidth / this.image.width), y * (this.image.naturalHeight / this.image.height), width, height, 0, 0, width, height);
                canvas.toBlob(blob => {
                    const result = blob ? new File([blob], fileName) : undefined;
                    resolve(result);
                }, type, 1);
            })
        });
        Object.defineProperty(this, "componentDidMount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.src = URL.createObjectURL(this.props.file))
        });
        Object.defineProperty(this, "componentWillUnmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.src) {
                    URL.revokeObjectURL(this.src);
                }
            }
        });
        Object.defineProperty(this, "handleChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (crop) => (this.crop = crop)
        });
        Object.defineProperty(this, "handleImageLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (image) => {
                this.image = image;
                this.crop = {
                    unit: 'px',
                    x: 0,
                    y: 0,
                    width: this.props.crop.width * (image.width / image.naturalWidth),
                    height: this.props.crop.height * (image.height / image.naturalHeight),
                };
                return false;
            }
        });
        mobx_1.makeObservable(this);
    }
    render() {
        return this.src ? (jsx_runtime_1.jsx(react_image_crop_1.default, { locked: true, src: this.src, crop: this.crop, onChange: this.handleChange, onImageLoaded: this.handleImageLoaded }, void 0)) : null;
    }
};
__decorate([
    mobx_1.observable,
    __metadata("design:type", String)
], ImageCropper.prototype, "src", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], ImageCropper.prototype, "crop", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", HTMLImageElement)
], ImageCropper.prototype, "image", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], ImageCropper.prototype, "componentDidMount", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], ImageCropper.prototype, "handleChange", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], ImageCropper.prototype, "handleImageLoaded", void 0);
ImageCropper = __decorate([
    mobx_react_1.observer,
    __metadata("design:paramtypes", [Object])
], ImageCropper);
exports.ImageCropper = ImageCropper;
//# sourceMappingURL=image-cropper.js.map